import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_PsychIntake = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_PsychIntake' className='file-pdf-document'>

            <div className='file-template'>
                <p>
                    <span className='eleHeader'>Narrative Summary:</span>
                    <span className='small'>(a synopsis of the clinical interview and the assessment is to be detailed here,
                        including information from the client/family, social and medical history, clinical inferences/judgments)</span>
                    <textarea id="txtIdentInformation1" name="txtIdentInformation1" className='add-only'></textarea>
                </p>
                <p>
                    <span className='eleHeader'>Treatment Course:</span>
                    <textarea id="txtIdentInformation_TreatCourse" name="txtIdentInformation_TreatCourse" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Diagnostic Impressions:</span>
                    <textarea id="txtDiagnosticImpressions" name="txtDiagnosticImpressions" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className="signature w-600">&nbsp;</td>
                        <td className="signature w-150">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-600">Psychologist Signature</td>
                        <td className="small w-150">Date</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
